import { FormattedMessage } from 'react-intl';

import type { Sport } from '__generated__/globalTypes';
import { Button } from 'atoms/buttons/Button';
import { ANY_SPORT_MARKET_WHEEL } from 'constants/__generated__/routes';
import { useEnabledWheelByRarity } from 'hooks/useEnabledWheelByRarity';
import { generateSportPath } from 'lib/routing/generateSportPath';

type Props = {
  nbTickets?: number;
  children?: React.ReactNode;
  sport?: Sport;
  onClick?: () => void;
};

export const SecondaryOrTickets = ({
  nbTickets = 2,
  sport,
  children,
  onClick,
}: Props): React.ReactNode => {
  const { limited } = useEnabledWheelByRarity();

  if (!sport || !limited || nbTickets === 0) {
    return children;
  }

  return (
    <Button
      to={generateSportPath(ANY_SPORT_MARKET_WHEEL, { sport })}
      color="transparent"
      fullWidth
      size="medium"
      onClick={onClick}
    >
      <FormattedMessage
        id="Wheel.Cta.GoSpinNow.v2"
        defaultMessage="Go Spin Now!"
      />
    </Button>
  );
};
